import './index.css';

import { Input } from 'antd';
import { PasswordProps } from 'antd/es/input';
import { useCallback } from 'react';

import { useValueHandle } from '../../hook/useValueHandle';
import { FloatingLabelBox } from '../FloatingLabelBox';

const { Password } = Input;

export interface FloatPasswordProps extends PasswordProps {
  required?: boolean;
}

export function FloatPassword({
  placeholder,
  onFocus,
  onBlur,
  value,
  defaultValue,
  style,
  onChange,
  required,
  ...restProps
}: FloatPasswordProps) {
  const { hasValue, handleChange, handleBlur, handleFocus, isFocus } =
    useValueHandle({
      id: restProps.id,
      defaultValue,
      value,
      onFocus,
      onBlur,
    });

  const changeHanlder = useCallback<
    Exclude<PasswordProps['onChange'], undefined>
  >(
    (value) => {
      handleChange(value);
      if (onChange) {
        onChange(value);
      }
    },
    [onChange]
  );

  return (
    <FloatingLabelBox
      label={placeholder}
      focused={isFocus}
      haveValue={hasValue}
      width={style?.width}
      height={style?.height}
      required={required}
      status={
        restProps.status || (restProps['aria-invalid'] ? 'error' : undefined)
      }
    >
      <Password
        style={style}
        className="w-full border-none py-2"
        variant="borderless"
        {...restProps}
        onFocus={handleFocus}
        onBlur={handleBlur}
        value={value}
        defaultValue={defaultValue}
        onChange={changeHanlder}
        rootClassName="ant-float-label-form-input-password"
      />
    </FloatingLabelBox>
  );
}
